angular
    .module('webcomm')
    .factory('dispositionService', [
        '$rootScope',
        '$log',
        'wtcpjsClientProviderService',
        'endpointModel',
        function (
            $rootScope,
            $log,
            wtcpjsClientProviderService,
            endpointModel) {

            // This service needs to be refactored to encapsulate known disposition states as well as track
            // disposition states for the user in a central place
            let service = {};
            let currentDisposition = '';

            let client = wtcpjsClientProviderService.getClient;

            service.setDisposition = function (endpointId, disposition) {
                client().setEndpointProperties(endpointId, {disposition}).then(() => {
                    currentDisposition = disposition;
                    $log.info(`set disposition endpoint property for endpointId ${endpointId} to ${disposition}`);
                    $rootScope.$broadcast('dispositionService.dispositionSet', disposition);
                });
            }

            var unbindIsReconnecting = $rootScope.$on('isReconnecting', (e, reconnecting, newEPId) => {
                if(!reconnecting && newEPId) {
                    if(currentDisposition === 'Phone') {
                        currentDisposition = 'Ready';
                    }

                    if(currentDisposition) {
                        $log.info('restoring disposition after reconnect');
                        service.setDisposition(newEPId, currentDisposition);
                    }
                }
            });

            $rootScope.$on('$destroy', () => {
                unbindIsReconnecting();
            });

            $log.debug('dispositionService initialized');
            return service;
        }
    ]);